import { render, staticRenderFns } from "./UpdateCategoryServiceDialog.vue?vue&type=template&id=1b434b84&scoped=true"
import script from "./UpdateCategoryServiceDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCategoryServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCategoryServiceDialog.vue?vue&type=style&index=0&id=1b434b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b434b84",
  null
  
)

export default component.exports